import React, { useState , useEffect} from 'react';
import { connect } from 'react-redux'
import {Grid, Fab, CircularProgress, Typography, Button, Box} from "@mui/material"
import MicIcon from '@mui/icons-material/Mic'
import {nextTask, taskNames} from '../../study-logic/study-redux-slice'
import {PageContainer} from "../../survey-tools/ui-components/containers"
import {CustomRecordingDoneDialog} from '../../survey-tools/custom-dialogue'; // Adjust the import path as needed


function ThinkAloudDisplay(props) {
    const {start, stop, isRecording, blobURL, nextTask} = props
    const [hasEnded, setHasEnded] = useState(false);

    const handleStart = () => {
        setHasEnded(true); 
        start();
    };

    const [openDialog, setOpenDialog] = useState(false);


    const buttonAction = isRecording ? stop : handleStart

    useEffect(() => {
        if (blobURL) {
            setOpenDialog(true);
        }
    }, [blobURL]);


    return (
        <PageContainer>
            <Grid item xs={11} sm={9} md={7} lg={5}
                  sx={{width: "100%", margin: "1em 0"}}>
                <Typography>
                    For 10 minutes, please report your thoughts and feelings as they come to you.
                    Click the button below to begin recording. The recording will
                    automatically stop when the time is up.
                </Typography>
            </Grid>
            <Box sx={{display: "flex", alignItems: "center",
                position: "relative", flexDirection: "column"}}>
                <Fab color='primary'
                     aria-label={'start-recording'}
                     sx={{margin: "6px 0"}}
                     disabled={isRecording || hasEnded}
                     onClick={buttonAction}>
                    <MicIcon />
                </Fab>
                {isRecording && <CircularProgress size={68}
                                                  sx={{
                                                      marginLeft: "-34px",
                                                      left: "50%",
                                                      position: "absolute"
                                                  }}
                                                  variant={'determinate'}
                                                  value={props.progress} />}
            </Box>

            {blobURL && <Grid item xs={11} sm={9} md={7} lg={5}
                              style={{width: '100%', display: 'flex', justifyContent: 'flex-end',
                                  alignSelf: 'center'}}>
                <Button variant={'contained'} color={'primary'}
                        onClick={() => nextTask({data: {[taskNames.thinkAloud]: blobURL}})}
                        style={{alignSelf: 'end', margin: '1em 0'}}>
                    next
                </Button>

                <CustomRecordingDoneDialog
    open={openDialog}
    onClose={() => setOpenDialog(false)}
    title="Recording Complete"
    description="The task is finished. You can now proceed to the next step."
    buttonText="OK"
/>


            </Grid>}
        </PageContainer>
    )
}

const mapDispatchToProps = {nextTask}
export default connect(null, mapDispatchToProps)(ThinkAloudDisplay)